import graphql from "babel-plugin-relay/macro"

export const HandleCallMutation = graphql`
  mutation CallingQuery_HandleCallMutation($input: HandleCallInput!) {
    handleCall(input: $input) {
      clientMutationId
      call {
        id
        callId
        status
        direction
        from
        to
        createdAt
        updatedAt
        etag
      }
    }
  }
`
